// extracted by mini-css-extract-plugin
export default {"question":"Faq_question__VRHCY","helpButton":"Faq_helpButton__Ymxd5","text":"Faq_text__Xzw1H"};